var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.195,
    height: 7.16,
    fill: "currentColor",
    viewBox: "0 0 11.195 7.16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_7447",
    "data-name": "Path 7447",
    d: "M8.876,12.666,12.914,16.7a1.553,1.553,0,0,0,2.2,0l4.038-4.038A1.564,1.564,0,0,0,18.043,10H9.967A1.559,1.559,0,0,0,8.876,12.666Z",
    transform: "translate(-8.414 -10)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdown);
export default __webpack_public_path__ + "static/media/dropdown.c68e35ffc55480957e5dfa5535c85b3c.svg";
export { ForwardRef as ReactComponent };